import React, { memo, useEffect, useState } from "react";
import {
  Card,
  Col,
  Form,
  InputGroup,
  Row
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import "./index.css";

import { isScopes } from "./../../services/Auth";
import { Creators as NipleOperationActions } from "../../store/ducks/nipleOperation";

const FilterNipleOperation = ({
  props: { currentUser },
  funcs: { setNipleOperationOperations, setNipleOperationGroupSeconds }
}) => {
  const { t } = useTranslation();
  const [operations, setOperations] = useState(["D"]);
  const [groupMinutes, setGroupMinutes] = useState(0);

  const canSelectOperations = isScopes({ currentUser, scopes: ["is:master"], every: false });

  const [operationOptions] = useState([
    { value: "C", label: t("Title.Niple.Charge") },
    { value: "D", label: t("Title.Niple.Discharge") },
    { value: "TC", label: t("Title.Niple.ChargeTest") },
    { value: "TD", label: t("Title.Niple.DischargeTest") }
  ]);

  const [groupMinutesOptions] = useState([
    { value: 0, label: "Sem agrupamento de operações" },
    { value: 1, label: "Agrupamento de 1 minuto" },
    { value: 2, label: "Agrupamento de 2 minutos" },
    { value: 3, label: "Agrupamento de 3 minutos" },
    { value: 4, label: "Agrupamento de 4 minutos" },
    { value: 10, label: "Agrupamento de 10 minutos" },
    { value: 15, label: "Agrupamento de 15 minutos" },
    { value: 20, label: "Agrupamento de 20 minutos" }
  ]);

  useEffect(() => {
    setNipleOperationOperations(operations);
  }, [operations]); /* eslint-disable-line */

  useEffect(() => {
    setNipleOperationGroupSeconds(groupMinutes * 60);
  }, [groupMinutes]); /* eslint-disable-line */

  return (
    <Card>
      <Card.Header>{t("Title.NipleOperationFilter")}</Card.Header>
      <Card.Body>
        <Row>
          {
            canSelectOperations ? (
              <Col>
                <div className="filter-niple-operation-fields">
                  <Form.Group>
                    <InputGroup className="mb-3">
                      <InputGroup.Prepend>
                        <InputGroup.Text><i className="fas fa-exchange-alt" /></InputGroup.Text>
                      </InputGroup.Prepend>
                      <Select
                        className="menu-outer-bottom filter-niple-operation-form-control"
                        classNamePrefix="select"
                        isMulti
                        placeholder={t("Placeholder.NipleOperationType")}
                        onChange={e => setOperations((e || []).map(item => item.value))}
                        options={operationOptions}
                        value={operationOptions.filter(x => operations.includes(x.value))}
                      />
                      <div className="filter-niple-operation-form-control-shaddow" />
                    </InputGroup>
                  </Form.Group>
                </div>
              </Col>
            ) : null
          }
          <Col>
            <div className="filter-niple-operation-fields">
              <Form.Group>
                <InputGroup className="mb-3">
                  <InputGroup.Prepend>
                    <InputGroup.Text><i className="fas fa-stopwatch" /></InputGroup.Text>
                  </InputGroup.Prepend>
                  <Select
                    className="menu-outer-bottom filter-niple-operation-form-control"
                    classNamePrefix="select"
                    onChange={e => setGroupMinutes(e.value)}
                    options={groupMinutesOptions}
                    value={groupMinutesOptions.find(x => x.value === groupMinutes)}
                  />
                  <div className="filter-niple-operation-form-control-shaddow" />
                </InputGroup>
              </Form.Group>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

const mapStateToProps = state => ({
  props: {
    currentUser: state.users.currentUser
  }
});

const mapDispatchToProps = dispatch => ({
  funcs: bindActionCreators(Object.assign({}, NipleOperationActions), dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(memo(FilterNipleOperation));
